"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gorreto": {
    "85769785": [{
      "hkey": "30607fe6",
      "slug": "gorreto",
      "name": "Gorreto",
      "primary": true,
      "skipSearch": false
    }],
    "borgo": [{
      "hkey": "30607fe6",
      "slug": "gorreto",
      "name": "Gorreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "abc6581b": [{
      "hkey": "30607fe6",
      "slug": "gorreto",
      "name": "Gorreto",
      "primary": true,
      "skipSearch": false
    }],
    "bosco": [{
      "hkey": "30607fe6",
      "slug": "gorreto",
      "name": "Gorreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "36011adc": [{
      "hkey": "30607fe6",
      "slug": "gorreto",
      "name": "Gorreto",
      "primary": true,
      "skipSearch": false
    }],
    "canneto": [{
      "hkey": "30607fe6",
      "slug": "gorreto",
      "name": "Gorreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e72ea0fd": [{
      "hkey": "30607fe6",
      "slug": "gorreto",
      "name": "Gorreto",
      "primary": true,
      "skipSearch": false
    }],
    "pissino": [{
      "hkey": "30607fe6",
      "slug": "gorreto",
      "name": "Gorreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;